import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
let token = null;
localStorage.removeItem("cbk_token");

export const getToken = () => token;
export const setToken = (t) => {
  token = t || null;
};
export const authHeaders = () => (token ? { Authorization: `Bearer ${token}` } : {});

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  Object.assign(cfg.headers, authHeaders());
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    if (error.response?.status === 401 && !original._retry && !String(original.url).includes("/auth/")) {
      original._retry = true;
      try {
        refreshing = refreshing || axios.post(`${BACKEND_URL}/api/auth/refresh`, {}, { withCredentials: true });
        const { data } = await refreshing;
        refreshing = null;
        setToken(data.access_token);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        refreshing = null;
        setToken(null);
        window.dispatchEvent(new Event("cbk:logout"));
      }
    }
    return Promise.reject(error);
  },
);

export function errorMessage(e, fallback = "Une erreur est survenue. Veuillez réessayer.") {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (typeof d?.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (detail?.message) return detail.conflicts ? `${detail.message} : ${detail.conflicts.join(" · ")}` : detail.message;
  return String(detail);
}

export async function streamAssistant(payload, { onSources, onDelta, onError, onDone }) {
  const res = await fetch(`${BACKEND_URL}/api/ai/assistant`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify(payload),
  });
  if (!res.ok || !res.body) {
    onError?.(`Assistant indisponible (${res.status})`);
    return;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop();
    for (const evt of events) {
      const lines = evt.split("\n");
      const type = lines.find((l) => l.startsWith("event:"))?.slice(6).trim() || "message";
      const dataLine = lines.find((l) => l.startsWith("data:"));
      if (!dataLine) continue;
      let data;
      try {
        data = JSON.parse(dataLine.slice(5).trim());
      } catch {
        data = dataLine.slice(5).trim();
      }
      if (type === "sources") onSources?.(data);
      else if (type === "error") onError?.(data);
      else if (type === "done") onDone?.();
      else onDelta?.(data);
    }
  }
  onDone?.();
}
